export class CollectionPointListReactivateCollectionPointsInput {
  collectionPoints: number[];

  constructor(collectionPoints: number[]) {
    this.collectionPoints = collectionPoints;
  }
}
